/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { userSessionIssuersCreate } from "../funcs/userSessionIssuersCreate.js";
import { userSessionIssuersDelete } from "../funcs/userSessionIssuersDelete.js";
import { userSessionIssuersGet } from "../funcs/userSessionIssuersGet.js";
import { userSessionIssuersGetAttachImpact } from "../funcs/userSessionIssuersGetAttachImpact.js";
import { userSessionIssuersList } from "../funcs/userSessionIssuersList.js";
import { userSessionIssuersUpdate } from "../funcs/userSessionIssuersUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import { UserSessionIssuerAttachImpact } from "../models/components/usersessionissuerattachimpact.js";
import {
  CreateUserSessionIssuerRequest,
  CreateUserSessionIssuerSecurity,
} from "../models/operations/createusersessionissuer.js";
import {
  DeleteUserSessionIssuerRequest,
  DeleteUserSessionIssuerSecurity,
} from "../models/operations/deleteusersessionissuer.js";
import {
  GetUserSessionIssuerRequest,
  GetUserSessionIssuerSecurity,
} from "../models/operations/getusersessionissuer.js";
import {
  GetUserSessionIssuerAttachImpactRequest,
  GetUserSessionIssuerAttachImpactSecurity,
} from "../models/operations/getusersessionissuerattachimpact.js";
import {
  ListUserSessionIssuersRequest,
  ListUserSessionIssuersResponse,
  ListUserSessionIssuersSecurity,
} from "../models/operations/listusersessionissuers.js";
import {
  UpdateUserSessionIssuerRequest,
  UpdateUserSessionIssuerSecurity,
} from "../models/operations/updateusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class UserSessionIssuers extends ClientSDK {
  /**
   * createUserSessionIssuer userSessionIssuers
   *
   * @remarks
   * Create a new user_session_issuer.
   */
  async create(
    request: CreateUserSessionIssuerRequest,
    security?: CreateUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(userSessionIssuersCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteUserSessionIssuer userSessionIssuers
   *
   * @remarks
   * Soft-delete a user_session_issuer. Cascades to dependent user_sessions, user_session_consents, and remote_session_clients.
   */
  async delete(
    request: DeleteUserSessionIssuerRequest,
    security?: DeleteUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(userSessionIssuersDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getUserSessionIssuer userSessionIssuers
   *
   * @remarks
   * Get a user_session_issuer by id or by slug. Provide exactly one.
   */
  async get(
    request?: GetUserSessionIssuerRequest | undefined,
    security?: GetUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(userSessionIssuersGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getAttachImpact userSessionIssuers
   *
   * @remarks
   * Preview what attaching a user_session_issuer to an existing MCP server, toolset, or meta MCP server changes for its clients, before calling the matching update. Name exactly one of mcp_server_id, toolset_id, or meta_mcp_server_id; omit user_session_issuer_id to preview detaching the current issuer. Clients and sessions belong to an issuer, so any change of issuer requires the server's clients to authorize again. Advisory only: the update does not require it. Requires the mcp:write access the matching update requires.
   */
  async getAttachImpact(
    request?: GetUserSessionIssuerAttachImpactRequest | undefined,
    security?: GetUserSessionIssuerAttachImpactSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuerAttachImpact> {
    return unwrapAsync(userSessionIssuersGetAttachImpact(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listUserSessionIssuers userSessionIssuers
   *
   * @remarks
   * List user_session_issuers in the caller's project.
   */
  async list(
    request?: ListUserSessionIssuersRequest | undefined,
    security?: ListUserSessionIssuersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListUserSessionIssuersResponse, { cursor: string }>> {
    return unwrapResultIterator(userSessionIssuersList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateUserSessionIssuer userSessionIssuers
   *
   * @remarks
   * Update fields on an existing user_session_issuer.
   */
  async update(
    request: UpdateUserSessionIssuerRequest,
    security?: UpdateUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(userSessionIssuersUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
